import script from "./path.vue?vue&type=script&setup=true&lang=ts"
export * from "./path.vue?vue&type=script&setup=true&lang=ts"

import "./path.vue?vue&type=style&index=0&id=7611dd22&lang=scss"

const __exports__ = script;

export default __exports__